import { Logger } from '@/shared/logger/logger';

// Common bot patterns in user agents
const BOT_PATTERNS = [
  /bot/i,
  /crawler/i,
  /spider/i,
  /googlebot/i,
  /bingbot/i,
  /yandex/i,
  /baidu/i,
  /duckduckgo/i,
  /slurp/i,
  /yahoo/i,
  /semrush/i,
  /ahrefs/i,
  /screaming frog/i,
  /pingdom/i,
  /phantomjs/i,
  /headless/i,
  /selenium/i,
  /puppet/i,
  /chrome-lighthouse/i,
  /pagespeed/i,
  /gtmetrix/i,
  /browsersync/i,
  /prerender/i,
];

export const BotDetector = {
  /**
   * Checks if a user agent string belongs to a bot
   * @param userAgent - The user agent string to check
   * @returns true if the user agent is from a bot, false otherwise
   */
  isBot(userAgent: string | undefined): boolean {
    if (!userAgent) {
      Logger.debug('No user agent provided, treating as bot');
      return true;
    }

    // Check if matches any bot pattern
    const isMatchingBotPattern = BOT_PATTERNS.some(pattern =>
      pattern.test(userAgent),
    );

    if (isMatchingBotPattern) {
      return true;
    }

    return false;
  },

  /**
   * Checks if we should skip event processing for this user agent
   * @param userAgent - The user agent string to check
   * @returns true if we should skip event processing, false otherwise
   */
  shouldSkipEventProcessing(userAgent: string | undefined): boolean {
    const isBot = BotDetector.isBot(userAgent);
    if (isBot) {
      Logger.debug('Skipping event processing for bot', { userAgent });
    }
    return isBot;
  },
};
